import { Capacitor, registerPlugin } from '@capacitor/core';

const SessionVault = registerPlugin('SessionVault');
const isAndroid = () => Capacitor.getPlatform() === 'android';

// Refresh credentials must never fall back to browser/localStorage persistence.
export async function getRefreshToken() {
  if (!isAndroid()) return null;
  const result = await SessionVault.get();
  return typeof result?.value === 'string' && result.value ? result.value : null;
}

export async function setRefreshToken(value) {
  if (!isAndroid()) return;
  if (typeof value !== 'string' || !value || value.length > 16384) {
    throw new Error('A non-empty refresh credential is required');
  }
  await SessionVault.set({ value });
}

export async function clearRefreshToken() {
  if (!isAndroid()) return;
  await SessionVault.clear();
}
